<template>
  <SearchBarColumn
    v-if="(suggestions && suggestions.length) || (redirectUrl && Object.keys(redirectUrl).length > 0)"
    class="suggestions"
    title="Suggestions"
  >
    <div v-if="redirectUrl && Object.keys(redirectUrl).length > 0" class="redirect-suggestions">
      <a class="accent" @keydown.enter="goToRedirectPage(redirectUrl.url)" :href="redirectUrl.url">
        {{ redirectUrl.title }}
      </a>
    </div>
    <div v-for="(suggestion, index) in suggestions" :key="suggestion.objectID" class="search-bar-suggestion">
      <a
        tabindex="0"
        @keydown.enter="onSearch(suggestion.query)"
        @keydown.esc="onExit"
        @click="onSearch(suggestion.query)"
        class="search-bar-suggestion-link keyboard-navigable"
      >
        <span class="highlighted-query" :key="suggestion.highlightedQuery" v-html="suggestion.highlightedQuery" />
      </a>
    </div>
  </SearchBarColumn>
</template>

<script>
export default { name: 'SearchBarSuggestions' };
</script>

<script setup>
import { computed, inject } from 'vue';
import SearchBarColumn from './SearchBarColumn.vue';

const props = defineProps({
  suggestions: {
    type: Object,
    required: true,
  },
  redirectUrl: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['onSearch', 'goToRedirectPage', 'onSearch']);

const onExit = inject('onExit');

function goToRedirectPage(url) {
  emit('goToRedirectPage', url);
}

function onSearch(query) {
  emit('onSearch', query);
}
</script>

<style lang="postcss" scoped>
span.highlighted-query {
  text-transform: capitalize;
  >>> em {
    font-weight: bold;
    font-style: normal;
  }
}
</style>
